import { render, staticRenderFns } from "./change_status.vue?vue&type=template&id=704084ed&scoped=true&"
import script from "./change_status.vue?vue&type=script&lang=js&"
export * from "./change_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704084ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704084ed')) {
      api.createRecord('704084ed', component.options)
    } else {
      api.reload('704084ed', component.options)
    }
    module.hot.accept("./change_status.vue?vue&type=template&id=704084ed&scoped=true&", function () {
      api.rerender('704084ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/reports/actions/change_status.vue"
export default component.exports